import React from 'react';
import { MDXProvider as BaseMDXProvider } from '@mdx-js/react';
import HtmlElements from '../../components/HtmlElements';

const MDXProvider = ({ children }: { children: React.ReactNode }) => (
    <BaseMDXProvider components={HtmlElements}>{children}</BaseMDXProvider>
);

export default MDXProvider;
